import { CustomSelect } from '@/slw/shared/ui/custom/select';

const sortOptions = [
  { label: 'Best match', value: 'best_match' },
  { label: 'Price - Lowest', value: 'Price-Lowest' },
  { label: 'Price - Highest', value: 'Price-Highest' },
  { label: 'Mileage - Lowest', value: 'Mileage-Lowest' },
  { label: 'Mileage - Highest', value: 'Mileage-Highest' },
  { label: 'Year - Newest', value: 'Year-Newest,' },
  { label: 'Year - Oldest', value: 'Year-Oldest' },
  { label: 'Listed - Newest', value: 'Listed-Newest' },
  { label: 'Listed - Oldest', value: 'Listed-Oldest' },
];

export function SortDropdown({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <div>
      <CustomSelect
        options={sortOptions}
        value={value}
        onChange={onChange}
        placeholder='Sort by'
        className='min-w-32.5 text-sm'
        size='md'
        color='white'
        contentClass={'max-h-[220px] overflow-auto'}
      />
    </div>
  );
}
